import React, { Fragment } from 'react'
import { isNumber, round } from 'lodash'

const humanizeGB = (amount, raw = false) => {
  let humanizedAmount = amount
  let symbol = 'GB'
  if (amount >= 1024) {
    humanizedAmount = amount / 1024
    symbol = 'TB'
  }

  if (raw) {
    return `${round(humanizedAmount, 2)} ${symbol}`
  }

  return <Fragment><i>{round(humanizedAmount, 2)}</i>{' '}{symbol}</Fragment>
}

const humanizeMB = (amount, raw = false) => {
  let humanizedAmount = amount
  let symbol = 'MB'
  if (amount >= 1024) {
    humanizedAmount = amount / 1024
    return humanizeGB(humanizedAmount)
  }

  if (raw) {
    return `${round(humanizedAmount, 2)} ${symbol}`
  }

  return <Fragment><i>{round(humanizedAmount, 2)}</i>{' '}{symbol}</Fragment>
}


const humanizeGhz = (amount) => (
  `${round(amount, 2)} GHz`
)

const humanize = (amount, unit = '') => {
  if (!isNumber(amount)) { return amount }

  return  `${round(amount, 2)} ${unit}`
}

export { humanizeMB, humanizeGB, humanizeGhz, humanize }
